import axios from 'axios';

import { useQuery } from 'react-query';

export default function useGetCharacteristicsByFamilyId(familyId) {
  const { data, isFetching, error } = useQuery(
    ['characteristics', { familyId }],
    async () => (await axios.get(`/idcards/characteristics/${familyId}`)).data,
    {
      enabled: !!familyId,
    }
  );

  return {
    characteristics: data,
    isLoading: isFetching,
    error,
  };
}
